import React from 'react';
import { getEventSessionTypeLabel } from '../../constants/venueEventSessionType';
export default function EventSessionTypeBadge({ value }) {
  return <span className="inline-block rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-700">{getEventSessionTypeLabel(value).toUpperCase()}</span>;
}
